import { MODULES ,TENDERED_COUNT_MESSAGE} from "../../../utils/constants";
import { LoadsList } from "../../../web/components/loads-list";
import React, { useEffect, useState } from "react";
import { IONICWrapper } from "../../../utils/common";
import { IonButton } from "@ionic/react";
import { loadCountFormatter, myLoadShowMore, showMoreButtonVisiblityWithCount, FetchFromMyLoadConfig } from "../../../utils/MyLoads.util";

const CarrierTenderedPage: React.FC<any> = (props: any) => {
  const [loads, setLoads] = useState<any[]>([]);
  const myLoadsMaxPageSize = FetchFromMyLoadConfig("PageSize");

  useEffect(() => {
    const data = props.loads || [];
    setLoads(data)
  }, [props.loads])

  return (
    <React.Fragment>
       {loads.length > 0 && (
        <div className="carrier-load-count-title">{loads.length} {TENDERED_COUNT_MESSAGE} </div>
      )}
      <LoadsList
        {...props}
        className={"myloads-list"}
        module={MODULES.CARRIER_TENDERED_MODULE}
        isCarrierLoad={true}
        loads={loads}
      />
      {!props?.location?.state?.isGlobalSearch && showMoreButtonVisiblityWithCount(props?.getMyLoadsFilteredCount?.carrierTenderedFilterCount || props?.count?.carrierTenderedCount,myLoadsMaxPageSize,props?.page) && loads?.length > 0 ?
     <IonButton className="btn-common-web" onClick={() => props.paginatedLoads(props?.page+1)}>
     Show {myLoadShowMore(myLoadsMaxPageSize,loads?.length,props?.getMyLoadsFilteredCount?.carrierTenderedFilterCount || props?.count?.carrierTenderedCount)} More
     </IonButton>:
      <div className="list-end-banner">
        <div className="end-list">
          <div className="left"></div>
          <div className="center">End of list</div>
          <div className="right"></div>
        </div>
      </div>}
    </React.Fragment>
  );
};

export default CarrierTenderedPage;
